<template>
  <div class="labelcell">
    <div class="lc-label" :class="{'is-required': required}">
      <slot name="label">{{label}}</slot>
    </div>
    <div class="lc-value">
      <slot name="content">{{content}}</slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
  },
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.labelcell {
  display: flex;
  padding: 8px 0;
  font-size: 14px;
}
.lc-label {
  margin-right: 4px;
  word-break: keep-all;
  display: flex;
  align-items: flex-start;
}
.is-required::before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
.lc-value {
  word-break: break-all;
  color: rgba($color: #000, $alpha: 0.65);
}
</style>
